"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Big;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AbstractTextElement = _interopRequireDefault(require("./AbstractTextElement"));

function Big(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_AbstractTextElement.default, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-big', className)
  }));
}

Big.propTypes = _AbstractTextElement.default.propTypes;
Big.defaultProps = _AbstractTextElement.default.defaultProps;
Big.displayName = 'Big';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/elements/Big.js
// module id = 652
// module chunks = 5 6